import { BrowserRouter, Route, Routes } from 'react-router-dom';
// components
import PrivateRoute from '@/components/PrivateRoute';
import Layout from '@/components/Layout';
import NotFound from '@/pages/NotFound';
import AuthCallback from '@/pages/AuthCallback';
import IntercomWidget from '@/modules/Intercom/components/Widget';
// utils
import { PATHS } from '@/constants';
import useAppStore from '@/store/app';
import routes from '@/routes.tsx';
import CreatePartnerOrganization from '@/pages/CreatePartnerOrganization';

const App = () => {
    const isAuthorized = useAppStore((state) => state.isAuthorized);
    const isCreatePartnerPage = location.pathname.includes(PATHS.createPartner);
    return (
        <BrowserRouter>
            {isAuthorized ? <IntercomWidget /> : undefined}
            <Routes>
                <Route
                    element={
                        <PrivateRoute
                            isAllowed={isAuthorized || isCreatePartnerPage}
                        />
                    }
                >
                    <Route element={<Layout />}>
                        {routes.private.map(({ path, element }) => {
                            return (
                                <Route
                                    element={element}
                                    key={path}
                                    path={path}
                                />
                            );
                        })}
                        <Route element={<NotFound />} path="*" />
                    </Route>
                </Route>
                <Route
                    element={<CreatePartnerOrganization />}
                    path={PATHS.createPartner}
                />
                <Route
                    element={<AuthCallback />}
                    path={PATHS.auth.login.callback}
                />
                <Route element={<NotFound />} path="*" />
            </Routes>
        </BrowserRouter>
    );
};

export default App;
